import React from 'react';

// Importing all sections used in the homepage
import { Home, About, Counter, Testimonials, Blogs, Services, NewsletterSection, Partners, Banner, Pricing, Process, Team, ProjectSection } from '../../sections';
import { Calculator } from '../../components';


const HomePage = () => {

  return (
    <div className='homepage'>
      <Home /> {/* Home Section */}
      <About /> {/* About Section */}
      <Services /> {/* Services Section */}
      <Counter /> {/* Counter Section */}
      <Process /> {/* Process Slider */}
      <Banner /> {/* Banner Section */}
      <ProjectSection /> {/* Project Section */}
      <Calculator /> {/* Calculator Section */}
      <Pricing /> {/* Pricing Section */}
      <Testimonials /> {/* Testimonials Slider */}
      <Team /> {/* Team Section */}
      <NewsletterSection /> {/* Newsletter subscription Section */}
      <Blogs /> {/* Latest blog posts */}
      <Partners /> {/* Partners Slider */}
    </div>
  )

}

export default HomePage;